import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import PrivateRoute from './components/PrivateRoute';
import Status from './pages/status/Status';
import Auth from './pages/auth/Auth';
import SignIn from './components/user/SignIn';
import useStores from './stores/useStores';
import ProtectedApp from './ProtectedApp';
import Onboarding from './pages/onboarding/Onboarding';

const App = () => {
  const { userStore } = useStores();

  if (userStore.status === 'loading') {
    return <div />;
  }

  if (userStore.status === 'UNDER_MAINTENANCE') {
    return (
      <Typography style={{ padding: '4rem', marginTop: 100 }} variant="h5">
        Platform is undergoing some maintenance. We&apos;ll be back soon...
      </Typography>
    );
  }

  let onboardingStep = null;

  if (userStore.user && userStore.user.is_onboarding_completed === false) {
    if (userStore.user.onboarding_step === 'onboarding-questions') {
      onboardingStep = 3;
    } else if (userStore.user.onboarding_step === 'create-project') {
      onboardingStep = 4;
    } else if (userStore.user.onboarding_step === 'validate-email') {
      onboardingStep = 6;
    }
  }

  return (
    <>
      <Switch>
        <Route
          exact
          path={['/auth/:method']}
          render={props => <Auth {...props} />}
        />
        <Route path="/status" exact render={props => <Status {...props} />} />
        <Route
          path={[
            '/login/:resetPasswordToken',
            '/login/activate/:userActivationToken',
            '/forgot-password'
          ]}
          exact
          render={props => <SignIn {...props} />}
        />
        {onboardingStep && (
          <Route
            exact
            render={props => (
              <Onboarding
                onboardingAnswers={userStore.user.onboarding_answers}
                onboardingStep={onboardingStep}
                {...props}
              />
            )}
          />
        )}
        <Route
          exact
          path={['/login', '/onboarding']}
          render={props => <Onboarding {...props} />}
        />
        <Route
          exact
          path="/register"
          render={props => <Onboarding onboardingStep={2} {...props} />}
        />

        <PrivateRoute userStore={userStore} path="/" component={ProtectedApp} />
      </Switch>
    </>
  );
};

export default observer(App);
